










































import {Component, Vue, Inject, Prop, Watch} from 'vue-property-decorator';
import Util from '@/lib/util'
import AbpBase from '@/lib/abpbase'
import PageRequest from '@/store/entities/page-request'
import CreateM from './create.vue'
import EditM from './edit.vue'
import dayjs from "dayjs";
import Campaign from "@/store/entities/campaign";
import Ajax from '@/lib/ajax'
import GiftPackage from "@/store/entities/gift-package";

class PageGiftInfoRequest extends PageRequest {
  campaignId: number;
}

@Component({
  components: {EditM, CreateM}
})
export default class GiftInfosVM extends AbpBase {
  edit() {
    this.editModalShow = true;
  }

  loadOptioning: boolean = false;
  pageRequest: PageGiftInfoRequest = new PageGiftInfoRequest();
  campaignList: Campaign[] = new Array<Campaign>();
  createModalShow: boolean = false;
  editModalShow: boolean = false;

  change(cid) {
    console.log(cid)
    let m = this.campaignList.find(x => x.id == cid);
    console.log(m)
    this.$store.commit('main/setCampaign', m)
  }

  async getCampaign() {
    this.loadOptioning = true;

    let response = await Ajax.get('/api/services/app/Campaign/GetAll', {params: {maxResultCount: 1000,dataState:1}});
    this.campaignList = response.data.result.items as Array<Campaign>;
    this.loadOptioning = false;
  }

  get list() {
    return this.$store.state.giftInfo.list;
  };

  get loading() {
    return this.$store.state.giftInfo.loading;
  }

  create() {

    let m = this.$store.state.main.campaign as Campaign;

    if (!m) {
      this.$Message.error('请选择活动');
      return;
    }

    this.createModalShow = true;
  }

  pageChange(page: number) {
    this.$store.commit('giftInfo/setCurrentPage', page);
    this.getpage();
  }

  pagesizeChange(pagesize: number) {
    this.$store.commit('giftInfo/setPageSize', pagesize);
    this.getpage();
  }

  async getpage() {


    this.pageRequest.maxResultCount = this.pageSize;
    this.pageRequest.skipCount = (this.currentPage - 1) * this.pageSize;

    await this.$store.dispatch({
      type: 'giftInfo/getAll',
      data: this.pageRequest
    })
  }

  get pageSize() {
    return this.$store.state.giftInfo.pageSize;
  }

  get totalCount() {
    return this.$store.state.giftInfo.totalCount;
  }

  get currentPage() {
    return this.$store.state.giftInfo.currentPage;
  }

  columns = [
    {
      title: this.L('ID'),
      key: 'id'
    },
    {
      title: this.L('活动代码'),
      key: 'campaignCode'
    },
    {
      title: this.L('奖品名称'),
      key: 'giftName'
    },
    {
      title: this.L('奖品代码'),
      key: 'giftCode'
    },
    {
      title: this.L('状态'),
      render: (h: any, params: any) => {
        return h('span', params.row.dataState == 1 ? this.L('启用') : this.L('禁用'))
      }
    },
    {
      title: this.L('备注'),
      key: 'remark'
    }
    , {
      title: this.L('Actions'),
      key: 'Actions',
      width: 150,
      render: (h: any, params: any) => {
        return h('div', [
          h('Button', {
            props: {
              type: 'primary',
              size: 'small'
            },
            style: {
              marginRight: '5px'
            },
            on: {
              click: () => {
                this.$store.commit('giftInfo/edit', params.row);
                this.edit();
              }
            }
          }, this.L('Edit')),
          h('Button', {
            props: {
              type: 'error',
              size: 'small'
            },
            on: {
              click: async () => {
                this.$Modal.confirm({
                  title: this.L('Tips'),
                  content: this.L('删除这个奖品？'),
                  okText: this.L('Yes'),
                  cancelText: this.L('No'),
                  onOk: async () => {
                    await this.$store.dispatch({
                      type: 'giftInfo/delete',
                      data: params.row
                    })
                    await this.getpage();
                  }
                })
              }
            }
          }, this.L('Delete'))
        ])
      }
    }]

  async created() {
    await this.getCampaign();
    let m = this.$store.state.main.campaign as Campaign;
    if (m) {
      this.pageRequest.campaignId = m.id;
    }
    await this.getpage();
  }
}
